import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Logo from '@/components/Logo'

import InviteForm from '@/components/Anon/InviteForm'
import ResetForm from '@/components/Anon/ResetForm'
import SignInForm from '@/components/Anon/SignInForm'
import PickDepartment from '@/components/Anon/PickDepartment'

const AnonComponent = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const anon = useSelector((state) => state.anon)
  const layout = useSelector((state) => state.layout)
  
  const [inviteToken, setInviteToken] = useState(false)
  const [resetToken, setResetToken] = useState(false)

  useEffect(() => {
    // check if invite
    const path = window.location.hash.split('/')
    const rxuuid = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

    // set property detail if url matches
    if (path[1] === 'invite' && path[2]) {
      setInviteToken(path[2])
    } else if (path[1] === 'reset-password' && path[2]) {
      setResetToken(path[2])
    }
  }, [])

  const setLogin = () => {
    setInviteToken(null)
    setResetToken(null)
    window.location.hash = ''
  }

  return (
    <main className="anon">
      <div className="anon_inner">
        <div className="form_wrapper">
          <Logo />
          {!user && inviteToken && (
            <InviteForm inviteToken={inviteToken} setLogin={setLogin} />
          )}
          {!user && resetToken && <ResetForm resetToken={resetToken} setLogin={setLogin} />}
          {!user && !inviteToken && !resetToken && <SignInForm />}
          {user && user.user && <PickDepartment />}
        </div>
      </div>
    </main>
  )
}

export default AnonComponent
